import React from 'react';
import PropTypes from 'prop-types';

function AuthFormContainer(props) {
  const { children, message, title } = props;

  return (
    <div className='fullPageFormContainer marginAbove'> 
      { message }
      
      <h2 className='formTitle'>{title}</h2>
      { children }        
    </div>
  );
}

AuthFormContainer.propTypes = {
  children: PropTypes.node,
  message: PropTypes.node,
  title: PropTypes.node
};

export default AuthFormContainer;
